import { render, staticRenderFns } from "./CasoSidebar.vue?vue&type=template&id=28efbd5d&scoped=true"
import script from "./CasoSidebar.vue?vue&type=script&lang=js"
export * from "./CasoSidebar.vue?vue&type=script&lang=js"
import style0 from "./CasoSidebar.vue?vue&type=style&index=0&id=28efbd5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28efbd5d",
  null
  
)

export default component.exports